<div
  class="bg-white flex flex-col gap-6 items-center p-6 relative rounded-2xl shadow-lg max-w-sm"
>
  <!-- Close button -->
  <button
    mat-icon-button
    class="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
    (click)="onCancel()"
  >
    <ui-icon name="close" size="20" mSize="20" fill="neutrals-600" class="" />
  </button>

  <!-- Illustration -->
  <div class="h-[100px] relative w-full">
    <div class="flex justify-center">
      <ui-illustrative-icon
        name="i-building"
        size="l"
        fill="yellow-700"
        class="icon-alert"
      ></ui-illustrative-icon>
    </div>
  </div>

  <!-- Content -->
  <div
    class="flex flex-col gap-4 items-center text-center w-full max-w-[246px]"
  >
    <ui-paragraph
      type="p16"
      mobile-type="p16"
      text-color="neutrals-900"
      font-weight="semibold"
    >
      ¡Algo salió mal!
    </ui-paragraph>

    <div class="flex flex-col gap-4">
      <ui-paragraph
        type="p12"
        mobile-type="p12"
        text-color="neutrals-700"
        font-weight="regular"
      >
        Por el momento, el sistema no puede cotizar dos unidades de negocio de
        forma conjunta.
      </ui-paragraph>

      <ui-paragraph
        type="p12"
        mobile-type="p12"
        text-color="neutrals-700"
        font-weight="regular"
      >
        Por favor, intenta nuevamente seleccionando una unidad a la vez.
      </ui-paragraph>
    </div>
  </div>

  <!-- Button -->
  <div class="w-full max-w-[246px]">
    <button
      type="button"
      class="w-full bg-unicon-yellow-100 text-[#0b2c56] font-semibold text-sm py-3.5 px-4 rounded-lg hover:bg-[#f5c63d] transition-colors"
      (click)="onContinue()"
    >
      Entendido
    </button>
  </div>
</div>
